import { AfterViewInit, Component, OnInit, signal, ViewChild } from '@angular/core';
import { CustomForms } from '../../forms/custom-forms';
import { environment } from 'src/environments/environment';

import { AppComponent } from 'src/app/app.component';
import { HeaderComponent } from '../../header/header.component';

import { jqxRibbonComponent } from 'jqwidgets-ng/jqxribbon';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { VehiculosMaquinariaResumenComponent } from './vehiculos-maquinaria-resumen/vehiculos-maquinaria-resumen.component';
import { MovilesCatalogComponent } from '../moviles-catalog/moviles-catalog.component';

@Component({
  selector: 'app-vehiculos-maquinaria',
  templateUrl: './vehiculos-maquinaria.component.html',
  styleUrl: './vehiculos-maquinaria.component.css'
})
export class VehiculosMaquinariaComponent extends CustomForms implements OnInit, AfterViewInit {
  @ViewChild('windVehiculoMaquinaria') windVehiculoMaquinaria: jqxWindowComponent;
  @ViewChild('header') header: HeaderComponent;
  @ViewChild('movilesRibbon') movilesRibbon: jqxRibbonComponent;

  @ViewChild('resumen') resumen: VehiculosMaquinariaResumenComponent;
  @ViewChild(MovilesCatalogComponent) movilesCatalog: MovilesCatalogComponent;

  componentRef: any;
  public environment = environment;

  protected showLoader: boolean = false;
  visualizarButtonVisible = signal(false);

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  constructor() {
    super();
  }

  public ngOnInit() {
  }

  public init(componentRef: any) {
    this.componentRef = componentRef;
  }

  public ngAfterViewInit(): void {
    this.addCustomForm(this.windVehiculoMaquinaria);
    this.windVehiculoMaquinaria.collapse();
    setTimeout(() => {
      this.windVehiculoMaquinaria.expand();
    }, 0);
  }
  public async onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  changeTab(event: any) {
    if (event.args.selectedIndex == 1) {
      this.visualizarButtonVisible.set(true);
    } else if (event.args.selectedIndex && event.args.selectedIndex !== 1) {
      this.visualizarButtonVisible.set(false);
    } else {
      return;
    }
  }
}
